import { PrescriptionRenewal, PrescriptionRenewalStatusEnum } from '../../../../entities/PrescriptionRenewal';
import { PrescriptionRenewalResponse } from '../../../../services/prescriptionRenewal.service';

export default class PrescriptionRenewalModel {
  static hasPendingRequest(prescriptionRenewalList: PrescriptionRenewal[] | null): boolean {
    return (
      Boolean(prescriptionRenewalList) &&
      prescriptionRenewalList!.length > 0 &&
      prescriptionRenewalList!.some(order => order.status === PrescriptionRenewalStatusEnum.PENDING)
    );
  }

  static addPendingRequest(
    prescriptionRenewalList: PrescriptionRenewal[] | null,
    order: PrescriptionRenewalResponse
  ): PrescriptionRenewal[] {
    return [order, ...(prescriptionRenewalList ?? [])];
  }
}
